
import { useStore } from 'vuex'
import { defineComponent, reactive, UnwrapRef, ref } from 'vue'
import { useRouter } from 'vue-router'
import { Modal } from 'ant-design-vue';

interface FormState {
  email: string;
}

export default defineComponent({
  setup () {
    const router = useRouter()
    const store = useStore()
    const isLoading = ref<boolean>(false)
    const userState: UnwrapRef<FormState> = reactive({
      email: '',
    })
    const showTryLimitModal = ref<boolean>(false)
    const retryAfter = ref<number>(0)

    const handleSubmit = (record: any) => {
      isLoading.value = true
      record.email = userState.email
      store
        .dispatch('AuthUser/accountRecovery', record)
        .then(function (res: any) {
          isLoading.value = false
          router.push({name: 'EmailSent', params: {email: record.email}})
        }).catch((error) => {
          isLoading.value = false

          if (error.response.status === 429) {
            const retrySeconds = error.response.headers['retry-after']
            const minutes = Math.floor(retrySeconds / 60)
            const seconds = retrySeconds - (minutes * 60)

            Modal.error({
              title: 'Reset limit reached.',
              content: 'You\'ve reached the maximum allowed password reset. Please try again in ' +
                  (minutes > 0 ? (minutes + ' minute' + (minutes > 1 ? 's' : '') + ' and ') : '') +
                  seconds + ' second' + (seconds > 1 ? 's' : '') + '.'
            });
          }
        })
    }

    return {
      userState,
      handleSubmit,
      isLoading,
      showTryLimitModal
    }
  },
})
